export default __webpack_public_path__ + "locales/vi/DownloadDialog.json?hash=5aded7d95e9da5f3d1fbc5f8dc4c2eed";